export enum LicenseType {
    FREE = 'free',
    FULL = 'full',
}
export default LicenseType;
